import { Input } from 'antd';
import React from 'react';
import './style.scss';

interface IProps {
    minLength?: number;
    maxLength?: number;
    showCount?: boolean;
    placeholder?: string;
    onChange?: (e: any) => void;
    field?: any;
    onBlur?: () => void;
    height?: number;
    onFocus?: () => void;
    value?: string | ReadonlyArray<string> | number | undefined;
    defaultValue?: string | number | ReadonlyArray<string> | undefined;
    disabled?: boolean;
    readOnly?: boolean;
    bordered?: boolean;
    type?: 'text' | 'password' | 'hidden' | 'file';
    accept?: string;
    allowClear?: boolean;
}

const InputWrap: React.FC<IProps> = ({
    field,
    minLength,
    maxLength,
    placeholder,
    onBlur,
    onFocus,
    onChange,
    height = 40,
    defaultValue,
    disabled,
    readOnly,
    bordered = true,
    accept,
    showCount = false,
    type = 'text',
    allowClear = false,
}) => {
    return (
        <Input
            className="input__wrap"
            onBlur={onBlur}
            onChange={onChange}
            onFocus={() => {
                if (onFocus) onFocus();
            }}
            showCount={showCount}
            height={height}
            minLength={minLength}
            maxLength={maxLength}
            placeholder={placeholder}
            defaultValue={defaultValue}
            disabled={disabled}
            readOnly={readOnly}
            type={type}
            accept={accept}
            bordered={bordered}
            allowClear={allowClear}
            {...field}
        />
    );
};

export default React.memo(InputWrap);
